/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { UserInviteDtoModel, UserInviteDtoModelType } from "./UserInviteDtoModel"
import { UserInviteDtoModelSelector } from "./UserInviteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  userInvite: UserInviteDtoModelType;
}

/**
 * UserInviteAcceptedDtoBase
 * auto generated base class for the model UserInviteAcceptedDtoModel.
 */
export const UserInviteAcceptedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('UserInviteAcceptedDto')
  .props({
    __typename: types.optional(types.literal("UserInviteAcceptedDto"), "UserInviteAcceptedDto"),
    /** User accepted the invite */
    userInvite: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => UserInviteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class UserInviteAcceptedDtoModelSelector extends QueryBuilder {
  userInvite(builder: string | UserInviteDtoModelSelector | ((selector: UserInviteDtoModelSelector) => UserInviteDtoModelSelector) | undefined) { return this.__child(`userInvite`, UserInviteDtoModelSelector, builder) }
}
export function selectFromUserInviteAcceptedDto() {
  return new UserInviteAcceptedDtoModelSelector()
}

export const userInviteAcceptedDtoModelPrimitives = selectFromUserInviteAcceptedDto()
